import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import { useConfigurationData } from "../utils/ConfigurationComponentUtils";
import { HtmlString } from "../../Utils";
import Moment from "moment";
var useStyles = makeStyles(function (theme) {
  return {
    container: {
      display: "flex",
      flexWrap: "wrap"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 220
    }
  };
});
export function formatDateConfigValue(value) {
  console.log("formatDateConfigValue: " + value);
  var formattedDateOrNull = value ? Moment(new Date(parseInt(value))).format("YYYY-MM-DDTHH:mm") : null;
  console.log("formattedDateOrNull: " + formattedDateOrNull);
  return formattedDateOrNull;
}

/**
 * Configuration component for a date value.
 * @param path - configuration path which uniquely identifies the configuration value bound to this component
 */
var ConfigurationDatePicker = function ConfigurationDatePicker(_ref) {
  var path = _ref.path,
    handleChanged = _ref.handleChanged,
    textFieldProps = _ref.textFieldProps;
  var classes = useStyles();
  var _useConfigurationData = useConfigurationData(path),
    _useConfigurationData2 = _slicedToArray(_useConfigurationData, 2),
    data = _useConfigurationData2[0],
    setData = _useConfigurationData2[1];
  var onChange = function onChange(event) {
    var formattedValue = event.target.value;
    var newData = _objectSpread({}, data);
    var date = formattedValue ? Moment(formattedValue).toDate().getTime() : null;
    newData.value = date;
    setData(newData);
    if (handleChanged) {
      handleChanged(newData);
    }
  };
  var formattedDateOrNull = formatDateConfigValue(data.value);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("form", {
    className: classes.container,
    noValidate: true
  }, /*#__PURE__*/React.createElement(TextField, Object.assign({
    id: "datetime",
    label: data.label,
    type: "datetime-local",
    defaultValue: formattedDateOrNull,
    className: classes.textField,
    onChange: onChange,
    InputLabelProps: {
      shrink: true
    }
  }, textFieldProps))));
};
export default ConfigurationDatePicker;